import { z } from "zod";

// Forced-password-change form (Story 2.11). Mirrors the shipped change-password
// backend (Story 2.7): `current_password` only needs to be non-empty (it is the temp
// password from the invite email — no policy applies), `new_password` must clear the
// 8-char minimum. Two client-only refinements give feedback before the round-trip:
//   - confirm must equal new (typo guard)
//   - new must differ from current (mirror of backend AUTH-010 PasswordUnchanged)
export const forcedPasswordChangeSchema = z
  .object({
    currentPassword: z.string().min(1, "Enter your current password."),
    newPassword: z.string().min(8, "Use at least 8 characters."),
    confirmPassword: z.string().min(1, "Re-enter your new password."),
  })
  .refine((values) => values.newPassword === values.confirmPassword, {
    message: "Passwords do not match.",
    path: ["confirmPassword"],
  })
  .refine(
    // Only compare once both fields are filled, so an empty form surfaces the
    // min-length errors rather than a spurious "choose a different password".
    (values) =>
      !values.currentPassword ||
      !values.newPassword ||
      values.newPassword !== values.currentPassword,
    {
      message: "Choose a password different from your current one.",
      path: ["newPassword"],
    },
  );

export type ForcedPasswordChangeValues = z.infer<typeof forcedPasswordChangeSchema>;
